(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b8-canvas-story-10"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(root){if(root.b8Cleanup)root.b8Cleanup();const controller=new AbortController();const signal=controller.signal;root.b8Cleanup=()=>controller.abort();const document={body:root,fonts:window.document.fonts,querySelector:s=>root.querySelector(s),querySelectorAll:s=>root.querySelectorAll(s),getElementById:id=>root.querySelector('[id="'+id+'"]')};const addEventListener=(name,fn,options={})=>window.addEventListener(name,()=>{if(root.isConnected)fn()}, {...options,signal});
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const reveals=[...document.querySelectorAll('.reveal')];
const chapters=[...document.querySelectorAll('[data-tone]')];
let paused=document.body.dataset.motion !== "true",pending=false; document.body.classList.toggle("paused",paused);
document.body.classList.add('motion-on');
const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('seen');observer.unobserve(e.target)}}),{threshold:.05});
reveals.forEach(el=>observer.observe(el)); signal.addEventListener("abort",()=>observer.disconnect());
function paint(){pending=false;if(paused||reduce.matches)return;const center=innerHeight*.48;let index=0;chapters.forEach((el,i)=>{if(el.getBoundingClientRect().top<=center)index=i});const current=chapters[index],next=chapters[Math.min(index+1,chapters.length-1)];const rect=current.getBoundingClientRect();const progress=Math.max(0,Math.min(1,(center-rect.top)/Math.max(1,rect.height)));const a=current.dataset.tone.split(',').map(Number),b=next.dataset.tone.split(',').map(Number);document.body.style.backgroundColor=`rgb(${a.map((v,i)=>Math.round(v+(b[i]-v)*progress)).join(',')})`;document.querySelectorAll('.scrub').forEach(el=>{const r=el.getBoundingClientRect();el.style.setProperty('--shift',`${Math.max(-16,Math.min(16,(innerHeight/2-r.top-r.height/2)*.045))}px`)})}
function schedule(){if(!pending){pending=true;requestAnimationFrame(paint)}}
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);schedule();
document.getElementById('motion-toggle').addEventListener('click',e=>{paused=!paused;document.body.classList.toggle('paused',paused);e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?document.body.dataset.resume:document.body.dataset.pause;schedule()});

const clips=[...root.querySelectorAll('[data-b8-video]')];const active=new Set();const syncClips=()=>clips.forEach(v=>{if(active.has(v)&&!paused&&!reduce.matches){v.play().catch(()=>{})}else{v.pause()}});const clipObserver=new IntersectionObserver(entries=>{for(const e of entries){if(e.isIntersecting)active.add(e.target);else active.delete(e.target)}syncClips()},{threshold:.15});clips.forEach(v=>clipObserver.observe(v));signal.addEventListener('abort',()=>{clipObserver.disconnect();clips.forEach(v=>v.pause())});document.getElementById('motion-toggle').addEventListener('click',syncClips);reduce.addEventListener('change',syncClips);
(() => {
  const rows = [
    ['Paper-like, no glow', 'Colour E Ink. No backlight.', 'Printed on paper.', 'Backlit LCD screen.'],
    ['Cord-free living', 'Rechargeable. No continuous power cable.', 'No power required.', 'Power needs vary by model.'],
    ['New photos, shared', 'App & remote image sharing.', 'Print and replace by hand.', 'Sharing varies by model.'],
    ['Playlists & schedules', 'Choose what changes, and when.', 'Change photos by hand.', 'Options vary by model.'],
    ['Everyday widgets', 'Calendar, weather, notes & more.', 'Static printed content.', 'Options vary by model.'],
    ['Local-first options', 'Desktop App, Open API & Home Assistant.', 'No connection needed.', 'Local access varies by model.']
  ];
  const table = document.getElementById('comparison-table');
  const section = document.querySelector('.comparison');
  const pin = document.querySelector('.compare-pin');
  const scroller = document.querySelector('.compare-scroll');
  const stage = document.querySelector('.photo-stage');
  const wall = document.querySelector('.photo-wall');
  const pair = document.querySelector('.casting-pair');
  const previous = document.getElementById('compare-prev');
  const next = document.getElementById('compare-next');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let pending = false, manual = false;
  const clamp = value => Math.max(0, Math.min(1, value));
  function buttons() { previous.disabled = scroller.scrollLeft < 2; next.disabled = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2; }
  function layout() {
    const enabled = !reduced.matches && !document.body.classList.contains('paused') && innerHeight > 780 && innerWidth > 700;
    const travel = scroller.scrollWidth - scroller.clientWidth;
    section.style.minHeight = enabled && travel > 0 ? `${pin.offsetHeight + Math.min(650, travel) + 100}px` : '0';
    update();
  }
  function update() {
    pending = false;
    if (reduced.matches || document.body.classList.contains('paused')) return;
    if (stage && wall && pair) {
    const rect = stage.getBoundingClientRect();
    const p = clamp((innerHeight - rect.top) / (innerHeight + rect.height));
    wall.style.setProperty('--wall-y', `${(p - .5) * -90}px`);
    pair.style.setProperty('--canvas-y', `${(p - .5) * 36}px`);
    }
    const r = section.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) manual = false;
    if (!manual && innerHeight > 780 && innerWidth > 700) {
      const range = section.offsetHeight - pin.offsetHeight - 40;
      if (range > 0) scroller.scrollLeft = clamp((20 - r.top) / range) * (scroller.scrollWidth - scroller.clientWidth);
    }
    buttons();
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  function move(direction) { manual = true; scroller.scrollBy({ left: direction * 260, behavior: reduced.matches ? 'instant' : 'smooth' }); }
  previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(event => scroller.addEventListener(event, () => { manual = true; }, { passive: true }));
  scroller.addEventListener('scroll', buttons, { passive: true });
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', layout);
  reduced.addEventListener('change', layout); document.getElementById('motion-toggle').addEventListener('click', layout);
  document.fonts.ready.then(()=>{if(!signal.aborted)layout()}); layout();
})();

(() => {
  document.querySelectorAll('[data-widget-icon]').forEach(card => {
    const source = [...document.querySelectorAll('#catalog>div')].find(item => item.dataset.icon === card.dataset.widgetIcon);
    const icon = source?.querySelector('svg');
    if (icon) card.prepend(icon.cloneNode(true));
  });
  const items = [...document.querySelectorAll('[data-drift]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  const photoStage = document.querySelector('.photo-stage');
  const photos = [...document.querySelectorAll('.photo-wall .memory')];
  function render() {
    queued = false;
    const still = reduced.matches || document.body.classList.contains('paused');
    const comparison = document.querySelector('.comparison');
    const comparisonTable = document.querySelector('#comparison-table');
    if (comparison && comparisonTable) {
      const top = comparisonTable.getBoundingClientRect().top;
      const amount = still ? 1 : Math.max(0,Math.min(1,(innerHeight*.95-top)/(innerHeight*.6)));
      comparison.style.setProperty('--others-opacity',String(.28+.72*amount));
    }
    if (photoStage) {
      const r = photoStage.getBoundingClientRect();
      const progress = still ? 1 : Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .8)));
      photos.forEach((photo, i) => {
        const directions = [[-1,-1],[1,-1],[-1,1],[1,1]];
        const [x,y] = directions[i];
        const distance = (1-progress) * Math.min(innerWidth * .35, 400);
        photo.style.translate = `${x*distance}px ${y*distance*.6}px`;
        photo.style.opacity = String(.25 + .75*progress);
      });
    }
    if (reduced.matches || document.body.classList.contains('paused')) return;
    for (const image of items) {
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > innerHeight + 80) continue;
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
      image.style.setProperty('--drift', `${progress * Number(image.dataset.drift)}px`);
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  reduced.addEventListener('change', schedule);
  document.getElementById('motion-toggle').addEventListener('click', schedule);
  schedule();
})();

}window.document.querySelectorAll('.b8-story10').forEach(mount);window.document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.b8-story10').forEach(mount));window.document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.b8-story10').forEach(root=>root.b8Cleanup?.()));})();
(()=>{let previous=scrollY,pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function init(){document.querySelectorAll('.modular-story').forEach(el=>{if(el.dataset.directionReady)return;el.dataset.directionReady='1';el.classList.toggle('is-expanded',reduced.matches);el.querySelector('.modular-replay')?.addEventListener('click',()=>{el.classList.remove('is-expanded');setTimeout(()=>el.classList.add('is-expanded'),450)})})}function draw(){pending=false;const delta=scrollY-previous;if(Math.abs(delta)<3)return;previous=scrollY;document.querySelectorAll('.modular-story').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight*.75&&r.bottom>innerHeight*.15)el.classList.toggle('is-expanded',reduced.matches||delta>0)})}init();addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(draw)}},{passive:true});document.addEventListener('shopify:section:load',init);reduced.addEventListener('change',()=>document.querySelectorAll('.modular-story').forEach(el=>el.classList.toggle('is-expanded',reduced.matches)))})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.cord-wall').forEach(el=>{const box=el.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;let p=reduced.matches?1:Math.max(0,Math.min(1,(innerHeight*.85-(box.top+box.height*.64))/(innerHeight*.30)));p=p*p*(3-2*p);el.style.setProperty('--cord-light',(0.78-0.32*p).toFixed(3));el.style.setProperty('--cord-rx',(65-43*p).toFixed(2)+'%');el.style.setProperty('--cord-ry',(50-31*p).toFixed(2)+'%')})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.private-mode-visual').forEach(el=>{const r=el.getBoundingClientRect();const visible=r.top>=innerHeight*.12&&r.bottom<=innerHeight*.72;el.classList.toggle('is-local',visible)})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b8-canvas-story-285"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(root){if(root.b8Cleanup)root.b8Cleanup();const controller=new AbortController();const signal=controller.signal;root.b8Cleanup=()=>controller.abort();const document={body:root,fonts:window.document.fonts,querySelector:s=>root.querySelector(s),querySelectorAll:s=>root.querySelectorAll(s),getElementById:id=>root.querySelector('[id="'+id+'"]')};const addEventListener=(name,fn,options={})=>window.addEventListener(name,()=>{if(root.isConnected)fn()}, {...options,signal});
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const reveals=[...document.querySelectorAll('.reveal')];
const chapters=[...document.querySelectorAll('[data-tone]')];
let paused=document.body.dataset.motion !== "true",pending=false; document.body.classList.toggle("paused",paused);
document.body.classList.add('motion-on');
const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('seen');observer.unobserve(e.target)}}),{threshold:.05});
reveals.forEach(el=>observer.observe(el)); signal.addEventListener("abort",()=>observer.disconnect());
function paint(){pending=false;if(paused||reduce.matches)return;const center=innerHeight*.48;let index=0;chapters.forEach((el,i)=>{if(el.getBoundingClientRect().top<=center)index=i});const current=chapters[index],next=chapters[Math.min(index+1,chapters.length-1)];const rect=current.getBoundingClientRect();const progress=Math.max(0,Math.min(1,(center-rect.top)/Math.max(1,rect.height)));const a=current.dataset.tone.split(',').map(Number),b=next.dataset.tone.split(',').map(Number);document.body.style.backgroundColor=`rgb(${a.map((v,i)=>Math.round(v+(b[i]-v)*progress)).join(',')})`;document.querySelectorAll('.scrub').forEach(el=>{const r=el.getBoundingClientRect();el.style.setProperty('--shift',`${Math.max(-16,Math.min(16,(innerHeight/2-r.top-r.height/2)*.045))}px`)})}
function schedule(){if(!pending){pending=true;requestAnimationFrame(paint)}}
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);schedule();
document.getElementById('motion-toggle').addEventListener('click',e=>{paused=!paused;document.body.classList.toggle('paused',paused);e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?document.body.dataset.resume:document.body.dataset.pause;schedule()});

(() => {
  const rows = [
    ['Paper-like, no glow', 'Colour E Ink. No backlight.', 'Printed on paper.', 'Backlit LCD screen.'],
    ['Cord-free living', 'Rechargeable. No continuous power cable.', 'No power required.', 'Power needs vary by model.'],
    ['New photos, shared', 'App & remote image sharing.', 'Print and replace by hand.', 'Sharing varies by model.'],
    ['Playlists & schedules', 'Choose what changes, and when.', 'Change photos by hand.', 'Options vary by model.'],
    ['Everyday widgets', 'Calendar, weather, notes & more.', 'Static printed content.', 'Options vary by model.'],
    ['Local-first options', 'Desktop App, Open API & Home Assistant.', 'No connection needed.', 'Local access varies by model.']
  ];
  const table = document.getElementById('comparison-table');
  const section = document.querySelector('.comparison');
  const pin = document.querySelector('.compare-pin');
  const scroller = document.querySelector('.compare-scroll');
  const stage = document.querySelector('.photo-stage');
  const wall = document.querySelector('.photo-wall');
  const pair = document.querySelector('.casting-pair');
  const previous = document.getElementById('compare-prev');
  const next = document.getElementById('compare-next');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let pending = false, manual = false;
  const clamp = value => Math.max(0, Math.min(1, value));
  function buttons() { previous.disabled = scroller.scrollLeft < 2; next.disabled = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2; }
  function layout() {
    const enabled = !reduced.matches && !document.body.classList.contains('paused') && innerHeight > 780 && innerWidth > 700;
    const travel = scroller.scrollWidth - scroller.clientWidth;
    section.style.minHeight = enabled && travel > 0 ? `${pin.offsetHeight + Math.min(650, travel) + 100}px` : '0';
    update();
  }
  function update() {
    pending = false;
    if (reduced.matches || document.body.classList.contains('paused')) return;
    if (stage && wall && pair) {
    const rect = stage.getBoundingClientRect();
    const p = clamp((innerHeight - rect.top) / (innerHeight + rect.height));
    wall.style.setProperty('--wall-y', `${(p - .5) * -90}px`);
    pair.style.setProperty('--canvas-y', `${(p - .5) * 36}px`);
    }
    const r = section.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) manual = false;
    if (!manual && innerHeight > 780 && innerWidth > 700) {
      const range = section.offsetHeight - pin.offsetHeight - 40;
      if (range > 0) scroller.scrollLeft = clamp((20 - r.top) / range) * (scroller.scrollWidth - scroller.clientWidth);
    }
    buttons();
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  function move(direction) { manual = true; scroller.scrollBy({ left: direction * 260, behavior: reduced.matches ? 'instant' : 'smooth' }); }
  previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(event => scroller.addEventListener(event, () => { manual = true; }, { passive: true }));
  scroller.addEventListener('scroll', buttons, { passive: true });
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', layout);
  reduced.addEventListener('change', layout); document.getElementById('motion-toggle').addEventListener('click', layout);
  document.fonts.ready.then(()=>{if(!signal.aborted)layout()}); layout();
})();

(() => {
  document.querySelectorAll('[data-widget-icon]').forEach(card => {
    const source = [...document.querySelectorAll('#catalog>div')].find(item => item.dataset.icon === card.dataset.widgetIcon);
    const icon = source?.querySelector('svg');
    if (icon) card.prepend(icon.cloneNode(true));
  });
  const items = [...document.querySelectorAll('[data-drift]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  const photoStage = document.querySelector('.photo-stage');
  const photos = [...document.querySelectorAll('.photo-wall .memory')];
  function render() {
    queued = false;
    const still = reduced.matches || document.body.classList.contains('paused');
    const comparison = document.querySelector('.comparison');
    const comparisonTable = document.querySelector('#comparison-table');
    if (comparison && comparisonTable) {
      const top = comparisonTable.getBoundingClientRect().top;
      const amount = still ? 1 : Math.max(0,Math.min(1,(innerHeight*.95-top)/(innerHeight*.6)));
      comparison.style.setProperty('--others-opacity',String(.28+.72*amount));
    }
    if (photoStage) {
      const r = photoStage.getBoundingClientRect();
      const progress = still ? 1 : Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .8)));
      photos.forEach((photo, i) => {
        const directions = [[-1,-1],[1,-1],[-1,1],[1,1]];
        const [x,y] = directions[i];
        const distance = (1-progress) * Math.min(innerWidth * .35, 400);
        photo.style.translate = `${x*distance}px ${y*distance*.6}px`;
        photo.style.opacity = String(.25 + .75*progress);
      });
    }
    if (reduced.matches || document.body.classList.contains('paused')) return;
    for (const image of items) {
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > innerHeight + 80) continue;
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
      image.style.setProperty('--drift', `${progress * Number(image.dataset.drift)}px`);
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  reduced.addEventListener('change', schedule);
  document.getElementById('motion-toggle').addEventListener('click', schedule);
  schedule();
})();

}window.document.querySelectorAll('.b8-story285').forEach(mount);window.document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.b8-story285').forEach(mount));window.document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.b8-story285').forEach(root=>root.b8Cleanup?.()));})();
(()=>{let previous=scrollY,pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function init(){document.querySelectorAll('.modular-story').forEach(el=>{if(el.dataset.directionReady)return;el.dataset.directionReady='1';el.classList.toggle('is-expanded',reduced.matches);el.querySelector('.modular-replay')?.addEventListener('click',()=>{el.classList.remove('is-expanded');setTimeout(()=>el.classList.add('is-expanded'),450)})})}function draw(){pending=false;const delta=scrollY-previous;if(Math.abs(delta)<3)return;previous=scrollY;document.querySelectorAll('.modular-story').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight*.75&&r.bottom>innerHeight*.15)el.classList.toggle('is-expanded',reduced.matches||delta>0)})}init();addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(draw)}},{passive:true});document.addEventListener('shopify:section:load',init);reduced.addEventListener('change',()=>document.querySelectorAll('.modular-story').forEach(el=>el.classList.toggle('is-expanded',reduced.matches)))})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.cord-wall').forEach(el=>{const box=el.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;let p=reduced.matches?1:Math.max(0,Math.min(1,(innerHeight*.85-(box.top+box.height*.64))/(innerHeight*.30)));p=p*p*(3-2*p);el.style.setProperty('--cord-light',(0.78-0.32*p).toFixed(3));el.style.setProperty('--cord-rx',(65-43*p).toFixed(2)+'%');el.style.setProperty('--cord-ry',(50-31*p).toFixed(2)+'%')})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.private-mode-visual').forEach(el=>{const r=el.getBoundingClientRect();const visible=r.top>=innerHeight*.12&&r.bottom<=innerHeight*.72;el.classList.toggle('is-local',visible)})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();





document.querySelectorAll('.b8-story285').forEach(root=>{
const demo=root.querySelector('.ripple-demo'),button=root.querySelector('.ripple-replay');
if(!demo||!button)return;
button.addEventListener('click',()=>{demo.classList.remove('playing');void demo.offsetWidth;demo.classList.add('playing')});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b8-canvas-story"] && !Shopify.designMode) return;
  try {
    
(()=>{function mount(root){if(root.b8Cleanup)root.b8Cleanup();const controller=new AbortController();const signal=controller.signal;root.b8Cleanup=()=>controller.abort();const document={body:root,fonts:window.document.fonts,querySelector:s=>root.querySelector(s),querySelectorAll:s=>root.querySelectorAll(s),getElementById:id=>root.querySelector('[id="'+id+'"]')};const addEventListener=(name,fn,options={})=>window.addEventListener(name,()=>{if(root.isConnected)fn()}, {...options,signal});
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const reveals=[...document.querySelectorAll('.reveal')];
const chapters=[...document.querySelectorAll('[data-tone]')];
let paused=document.body.dataset.motion !== "true",pending=false; document.body.classList.toggle("paused",paused);
document.body.classList.add('motion-on');
const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('seen');observer.unobserve(e.target)}}),{threshold:.05});
reveals.forEach(el=>observer.observe(el)); signal.addEventListener("abort",()=>observer.disconnect());
function paint(){pending=false;if(paused||reduce.matches)return;const center=innerHeight*.48;let index=0;chapters.forEach((el,i)=>{if(el.getBoundingClientRect().top<=center)index=i});const current=chapters[index],next=chapters[Math.min(index+1,chapters.length-1)];const rect=current.getBoundingClientRect();const progress=Math.max(0,Math.min(1,(center-rect.top)/Math.max(1,rect.height)));const a=current.dataset.tone.split(',').map(Number),b=next.dataset.tone.split(',').map(Number);document.body.style.backgroundColor=`rgb(${a.map((v,i)=>Math.round(v+(b[i]-v)*progress)).join(',')})`;document.querySelectorAll('.scrub').forEach(el=>{const r=el.getBoundingClientRect();el.style.setProperty('--shift',`${Math.max(-16,Math.min(16,(innerHeight/2-r.top-r.height/2)*.045))}px`)})}
function schedule(){if(!pending){pending=true;requestAnimationFrame(paint)}}
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);schedule();
document.getElementById('motion-toggle').addEventListener('click',e=>{paused=!paused;document.body.classList.toggle('paused',paused);e.currentTarget.setAttribute('aria-pressed',String(paused));e.currentTarget.textContent=paused?document.body.dataset.resume:document.body.dataset.pause;schedule()});

(() => {
  const rows = [
    ['Paper-like, no glow', 'Colour E Ink. No backlight.', 'Printed on paper.', 'Backlit LCD screen.'],
    ['Cord-free living', 'Rechargeable. No continuous power cable.', 'No power required.', 'Power needs vary by model.'],
    ['New photos, shared', 'App & remote image sharing.', 'Print and replace by hand.', 'Sharing varies by model.'],
    ['Playlists & schedules', 'Choose what changes, and when.', 'Change photos by hand.', 'Options vary by model.'],
    ['Everyday widgets', 'Calendar, weather, notes & more.', 'Static printed content.', 'Options vary by model.'],
    ['Local-first options', 'Desktop App, Open API & Home Assistant.', 'No connection needed.', 'Local access varies by model.']
  ];
  const table = document.getElementById('comparison-table');
  const section = document.querySelector('.comparison');
  const pin = document.querySelector('.compare-pin');
  const scroller = document.querySelector('.compare-scroll');
  const stage = document.querySelector('.photo-stage');
  const wall = document.querySelector('.photo-wall');
  const pair = document.querySelector('.casting-pair');
  const previous = document.getElementById('compare-prev');
  const next = document.getElementById('compare-next');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let pending = false, manual = false;
  const clamp = value => Math.max(0, Math.min(1, value));
  function buttons() { previous.disabled = scroller.scrollLeft < 2; next.disabled = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 2; }
  function layout() {
    const enabled = !reduced.matches && !document.body.classList.contains('paused') && innerHeight > 780 && innerWidth > 700;
    const travel = scroller.scrollWidth - scroller.clientWidth;
    section.style.minHeight = enabled && travel > 0 ? `${pin.offsetHeight + Math.min(650, travel) + 100}px` : '0';
    update();
  }
  function update() {
    pending = false;
    if (reduced.matches || document.body.classList.contains('paused')) return;
    if (stage && wall && pair) {
    const rect = stage.getBoundingClientRect();
    const p = clamp((innerHeight - rect.top) / (innerHeight + rect.height));
    wall.style.setProperty('--wall-y', `${(p - .5) * -90}px`);
    pair.style.setProperty('--canvas-y', `${(p - .5) * 36}px`);
    }
    const r = section.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) manual = false;
    if (!manual && innerHeight > 780 && innerWidth > 700) {
      const range = section.offsetHeight - pin.offsetHeight - 40;
      if (range > 0) scroller.scrollLeft = clamp((20 - r.top) / range) * (scroller.scrollWidth - scroller.clientWidth);
    }
    buttons();
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  function move(direction) { manual = true; scroller.scrollBy({ left: direction * 260, behavior: reduced.matches ? 'instant' : 'smooth' }); }
  previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(event => scroller.addEventListener(event, () => { manual = true; }, { passive: true }));
  scroller.addEventListener('scroll', buttons, { passive: true });
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', layout);
  reduced.addEventListener('change', layout); document.getElementById('motion-toggle').addEventListener('click', layout);
  document.fonts.ready.then(()=>{if(!signal.aborted)layout()}); layout();
})();

(() => {
  document.querySelectorAll('[data-widget-icon]').forEach(card => {
    const source = [...document.querySelectorAll('#catalog>div')].find(item => item.dataset.icon === card.dataset.widgetIcon);
    const icon = source?.querySelector('svg');
    if (icon) card.prepend(icon.cloneNode(true));
  });
  const items = [...document.querySelectorAll('[data-drift]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let queued = false;
  const photoStage = document.querySelector('.photo-stage');
  const photos = [...document.querySelectorAll('.photo-wall .memory')];
  function render() {
    queued = false;
    const still = reduced.matches || document.body.classList.contains('paused');
    const comparison = document.querySelector('.comparison');
    const comparisonTable = document.querySelector('#comparison-table');
    if (comparison && comparisonTable) {
      const top = comparisonTable.getBoundingClientRect().top;
      const amount = still ? 1 : Math.max(0,Math.min(1,(innerHeight*.95-top)/(innerHeight*.6)));
      comparison.style.setProperty('--others-opacity',String(.28+.72*amount));
    }
    if (photoStage) {
      const r = photoStage.getBoundingClientRect();
      const progress = still ? 1 : Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .8)));
      photos.forEach((photo, i) => {
        const directions = [[-1,-1],[1,-1],[-1,1],[1,1]];
        const [x,y] = directions[i];
        const distance = (1-progress) * Math.min(innerWidth * .35, 400);
        photo.style.translate = `${x*distance}px ${y*distance*.6}px`;
        photo.style.opacity = String(.25 + .75*progress);
      });
    }
    if (reduced.matches || document.body.classList.contains('paused')) return;
    for (const image of items) {
      const rect = image.parentElement.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > innerHeight + 80) continue;
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
      image.style.setProperty('--drift', `${progress * Number(image.dataset.drift)}px`);
    }
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(render); } }
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  reduced.addEventListener('change', schedule);
  document.getElementById('motion-toggle').addEventListener('click', schedule);
  schedule();
})();

}window.document.querySelectorAll('.b8-story').forEach(mount);window.document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.b8-story').forEach(mount));window.document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.b8-story').forEach(root=>root.b8Cleanup?.()));})();
(()=>{let previous=scrollY,pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function init(){document.querySelectorAll('.modular-story').forEach(el=>{if(el.dataset.directionReady)return;el.dataset.directionReady='1';el.classList.toggle('is-expanded',reduced.matches);el.querySelector('.modular-replay')?.addEventListener('click',()=>{el.classList.remove('is-expanded');setTimeout(()=>el.classList.add('is-expanded'),450)})})}function draw(){pending=false;const delta=scrollY-previous;if(Math.abs(delta)<3)return;previous=scrollY;document.querySelectorAll('.modular-story').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight*.75&&r.bottom>innerHeight*.15)el.classList.toggle('is-expanded',reduced.matches||delta>0)})}init();addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(draw)}},{passive:true});document.addEventListener('shopify:section:load',init);reduced.addEventListener('change',()=>document.querySelectorAll('.modular-story').forEach(el=>el.classList.toggle('is-expanded',reduced.matches)))})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.cord-wall').forEach(el=>{const box=el.getBoundingClientRect();if(box.bottom<0||box.top>innerHeight)return;let p=reduced.matches?1:Math.max(0,Math.min(1,(innerHeight*.85-(box.top+box.height*.64))/(innerHeight*.30)));p=p*p*(3-2*p);el.style.setProperty('--cord-light',(0.78-0.32*p).toFixed(3));el.style.setProperty('--cord-rx',(65-43*p).toFixed(2)+'%');el.style.setProperty('--cord-ry',(50-31*p).toFixed(2)+'%')})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();
(()=>{let pending=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');function draw(){pending=false;document.querySelectorAll('.private-mode-visual').forEach(el=>{const r=el.getBoundingClientRect();const visible=r.top>=innerHeight*.12&&r.bottom<=innerHeight*.72;el.classList.toggle('is-local',visible)})}function schedule(){if(!pending){pending=true;requestAnimationFrame(draw)}}addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);reduced.addEventListener('change',schedule);schedule()})();





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kol-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-kol-gallery]').forEach((section) => {
      const track = section.querySelector('[data-kol-track]');
      const prev = section.querySelector('[data-kol-prev]');
      const next = section.querySelector('[data-kol-next]');
      const modal = section.querySelector('[data-kol-modal]');
      const modalInner = section.querySelector('[data-kol-modal-inner]');
      const modalFrame = section.querySelector('[data-kol-modal-frame]');
      const videos = Array.from(section.querySelectorAll('[data-kol-video]'));
      let resumeVideo = null;
      let userPrefersMuted = false;

      if (!track) return;

      const setCardPlaying = (video, isPlaying) => {
        const card = video.closest('.b8-kol-gallery__card');
        const playButton = card?.querySelector('[data-kol-play]');

        card?.classList.toggle('is-playing', isPlaying);
        playButton?.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      };

      const setVideoMuted = (video, isMuted) => {
        const card = video.closest('.b8-kol-gallery__card');
        const muteButton = card?.querySelector('[data-kol-mute]');

        video.muted = isMuted;
        muteButton?.setAttribute('aria-pressed', String(isMuted));
        muteButton?.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
      };

      const pauseVideo = (video, options = {}) => {
        if (!video) return;

        video.pause();

        if (options.mute !== false) {
          setVideoMuted(video, true);
        }

        setCardPlaying(video, false);
      };

      const pauseOtherVideos = (activeVideo) => {
        videos.forEach((video) => {
          if (video !== activeVideo) {
            pauseVideo(video);
          }
        });
      };

      const pauseAllVideos = () => {
        resumeVideo = null;
        videos.forEach((video) => pauseVideo(video));
      };

      const playVideo = (video) => {
        if (!video) return;

        pauseOtherVideos(video);
        setVideoMuted(video, userPrefersMuted);

        const playPromise = video.play();
        setCardPlaying(video, true);

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            if (!video.muted) {
              setVideoMuted(video, true);

              const mutedPlayPromise = video.play();
              setCardPlaying(video, true);

              if (mutedPlayPromise && typeof mutedPlayPromise.catch === 'function') {
                mutedPlayPromise.catch(() => setCardPlaying(video, false));
              }

              return;
            }

            setCardPlaying(video, false);
          });
        }
      };

      const getStep = () => {
        const card = track.querySelector('.b8-kol-gallery__card');
        if (!card) return 0;

        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        if (!prev || !next) return;

        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollByCard = (direction) => {
        const step = getStep();
        if (!step) return;
        pauseAllVideos();
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      track.addEventListener(
        'scroll',
        () => {
          updateNav();
          pauseAllVideos();
        },
        { passive: true }
      );
      window.addEventListener('resize', updateNav);
      updateNav();

      const closeModal = () => {
        if (!modal || !modalFrame) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalFrame.src = '';
      };

      modal?.addEventListener('click', closeModal);
      modalInner?.addEventListener('click', (event) => event.stopPropagation());

      videos.forEach((video) => {
        setVideoMuted(video, true);

        video.addEventListener('click', () => {
          if (video.paused) {
            playVideo(video);
          } else {
            pauseVideo(video, { mute: false });
          }
        });

        video.addEventListener('pause', () => setCardPlaying(video, false));
        video.addEventListener('play', () => setCardPlaying(video, true));
      });

      section.querySelectorAll('[data-kol-mute]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          const card = button.closest('.b8-kol-gallery__card');
          const video = card?.querySelector('[data-kol-video]');

          if (!video) return;

          userPrefersMuted = !video.muted;
          setVideoMuted(video, userPrefersMuted);
        });
      });

      if ('IntersectionObserver' in window) {
        const viewportObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio < 0.15) {
                const playingVideo = videos.find((video) => !video.paused);

                if (playingVideo) {
                  resumeVideo = playingVideo;
                  pauseVideo(playingVideo);
                }
              } else if (entry.intersectionRatio >= 0.4 && resumeVideo) {
                const videoToResume = resumeVideo;
                resumeVideo = null;
                playVideo(videoToResume);
              }
            });
          },
          { threshold: [0, 0.15, 0.4] }
        );

        viewportObserver.observe(section);
      }

      section.querySelectorAll('[data-kol-play]').forEach((button) => {
        button.addEventListener('click', () => {
          const youtubeId = button.dataset.kolYoutubeId;
          const shortUrl = button.dataset.kolShortUrl;

          if (youtubeId && modal && modalFrame) {
            modalFrame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1`;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            return;
          }

          if (shortUrl) {
            const popup = window.open(shortUrl, '_blank', 'noopener,noreferrer');
            if (popup) popup.opener = null;
            return;
          }

          const card = button.closest('.b8-kol-gallery__card');
          const video = card?.querySelector('[data-kol-video]');

          if (!card || !video) return;

          if (video.paused) {
            playVideo(video);
          } else {
            pauseVideo(video, { mute: false });
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-image"] && !Shopify.designMode) return;
  try {
    
  const initB8UserImageGrid = (container) => {
    if (!container) return;

    const cards = Array.from(container.querySelectorAll('.b8-user-image__card'));
    if (!cards.length) return;

    const mediaQuery = window.matchMedia('(max-width: 749px)');

    const sortCards = (isMobile) => {
      const sortAttr = isMobile ? 'data-mobile-order' : 'data-desktop-order';

      cards
        .sort((a, b) => {
          return (
            parseInt(a.getAttribute(sortAttr), 10) - parseInt(b.getAttribute(sortAttr), 10)
          );
        })
        .forEach((card) => container.appendChild(card));
    };

    sortCards(mediaQuery.matches);

    if (container.dataset.b8UserImageBound === 'true') return;
    container.dataset.b8UserImageBound = 'true';

    mediaQuery.addEventListener('change', (event) => {
      sortCards(event.matches);
    });
  };

  const bootB8UserImageGrids = () => {
    document.querySelectorAll('[id^="b8-user-image-grid-"]').forEach(initB8UserImageGrid);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootB8UserImageGrids, { once: true });
  } else {
    bootB8UserImageGrids();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const grid = event.target.querySelector('[id^="b8-user-image-grid-"]');
    if (grid) initB8UserImageGrid(grid);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-users-say"] && !Shopify.designMode) return;
  try {
    
  const initUsersSaySwiper = (root) => {
    const el = root.querySelector('[data-users-say-swiper]');
    if (!el || typeof Swiper === 'undefined') return;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
    });
  };

  const bootAllUsersSaySwipers = () => {
    document.querySelectorAll('.b8-users-say').forEach(initUsersSaySwiper);
  };

  const bootWhenReady = () => {
    if (typeof Swiper === 'undefined') return false;
    bootAllUsersSaySwipers();
    return true;
  };

  const scheduleBoot = () => {
    if (bootWhenReady()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (bootWhenReady() || attempts >= 120) {
        window.clearInterval(timer);
      }
    }, 16);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot, { once: true });
  } else {
    scheduleBoot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.b8-users-say');
    if (section) initUsersSaySwiper(section);
  });

  } catch(e) { console.error(e); }
})();
})();
